import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { PlusSignIcon } from "@hugeicons-pro/core-stroke-rounded";

const ConditionsEmptyIcon = () => (
  <div className="w-20 h-20 rounded-full bg-primary-50 flex items-center justify-center mb-4">
    <svg
      width="36"
      height="36"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      className="text-primary-400"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="5" r="2" />
      <circle cx="6" cy="19" r="2" />
      <circle cx="18" cy="19" r="2" />
      <path d="M12 7v4" />
      <path d="M12 11L6 17" />
      <path d="M12 11l6 6" />
    </svg>
  </div>
);

export const NoConditions = ({ onAdd }: { onAdd: () => void }) => {
  return (
    <div className="w-full flex flex-col items-center justify-center min-h-[calc(100vh-200px)]">
      <ConditionsEmptyIcon />
      <h2 className="text-lg font-semibold text-content-1000 mb-1">
        Conditions will appear here
      </h2>
      <p className="text-sm text-content-600 mb-6">
        Show or hide questions based on answers
      </p>
      <Button
        size={ButtonSize.SM}
        variant={ButtonVariant.PRIMARY}
        HugeIcon={PlusSignIcon}
        onClick={onAdd}
      >
        Add condition
      </Button>
    </div>
  );
};
